import { Stack, Typography } from "@mui/material";
import * as React from "react";

// Inline SVG component like other icons in the codebase
const LoadingSpinner: React.FC = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    style={{ margin: "auto", background: "transparent", display: "block", shapeRendering: "auto" }} 
    width="150px" 
    height="150px" 
    viewBox="0 0 100 100" 
    preserveAspectRatio="xMidYMid"
  >
    <g transform="translate(26.666666666666668,26.666666666666668)">
      <rect x="-20" y="-20" width="40" height="40" fill="#000000">
        <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1.1111111111111112s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.3333333333333333s"></animateTransform>
      </rect>
    </g>
    <g transform="translate(73.33333333333333,26.666666666666668)">
      <rect x="-20" y="-20" width="40" height="40" fill="#e13123">
        <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1.1111111111111112s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.22222222222222224s"></animateTransform>
      </rect>
    </g>
    <g transform="translate(26.666666666666668,73.33333333333333)">
      <rect x="-20" y="-20" width="40" height="40" fill="#e13123">
        <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1.1111111111111112s" keyTimes="0;1" values="1.1500000000000001;1" begin="0s"></animateTransform>
      </rect>
    </g>
    <g transform="translate(73.33333333333333,73.33333333333333)">
      <rect x="-20" y="-20" width="40" height="40" fill="#000000">
        <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1.1111111111111112s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.11111111111111112s"></animateTransform>
      </rect>
    </g>
  </svg>
);

export const Loading: React.FC<{
  message?: string;
}> = ({ message }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{ height: "100%", width: "100%" }}
  >
    <LoadingSpinner />
    {// If a message is provided, display it
    message && <Typography>{message}</Typography>}
  </Stack>
);
